<ion-content>
  <div class="container" [ngClass]="{
    'applause-bg': countdownBg == 0,
    'forest-bg': countdownBg == 1
  }" (click)="onCloseModal()">
    <span class="gradient-prefix"></span>
    <div class="content">
      <div class="signal-div" *ngIf="lowGpsSignal">
        <img src=".. /../assets/imgs/countdown/low_signal.png">
        <p>{{'WEAK_GPS_SIGNAL'| translate}}</p>
      </div>
      <div class="signal-div" *ngIf="noGpsSignal">
        <img src="../../assets/imgs/countdown/no_signal.png">
        <p>{{'NO_GPS_SIGNAL' | translate}}</p>
      </div>
      <div class="signal-div" *ngIf="highGpsSignal">
        <img src="../../assets/imgs/countdown/high_signal.png">
        <p>{{'STRONG_GPS_SIGNAL' | translate}}</p>
      </div>

      <p class="number">{{counter}}</p>
      <p>{{ 'START_IMMEDIATELY' | translate }}</p>
    </div>
  </div>
</ion-content>